// Whitelist renderer for the legal source-of-truth structured body (§22/§42).
// Never uses dangerouslySetInnerHTML. Silently skips unknown block/style
// values so a defensive frontend cannot be broken by a rogue backend record.

const ALLOWED_STYLES = new Set(["normal", "strong", "italic"]);

function ParagraphBlock({ block }) {
  const style = ALLOWED_STYLES.has(block.style) ? block.style : "normal";
  const cls =
    style === "strong"
      ? "font-semibold text-foreground"
      : style === "italic"
      ? "italic text-foreground"
      : "text-foreground/90";
  return <p className={`text-sm sm:text-[15px] leading-relaxed ${cls}`}>{block.text}</p>;
}

function ParagraphWithLinkBlock({ block }) {
  const style = ALLOWED_STYLES.has(block.style) ? block.style : "normal";
  const cls =
    style === "strong"
      ? "font-semibold text-foreground"
      : style === "italic"
      ? "italic text-foreground"
      : "text-foreground/90";
  return (
    <p className={`text-sm sm:text-[15px] leading-relaxed ${cls}`}>
      {block.text}{" "}
      <a
        href={block.link_url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-primary underline underline-offset-2 hover:text-primary/80"
        data-testid="terms-general-link"
      >
        {block.link_text}
      </a>
      .
    </p>
  );
}

function BulletListBlock({ block }) {
  return (
    <ul className="list-disc pl-6 space-y-1.5 text-sm sm:text-[15px] leading-relaxed text-foreground/90">
      {block.items.map((it, i) => (
        <li key={i}>{it}</li>
      ))}
    </ul>
  );
}

export default function StepRenderer({ body }) {
  if (!Array.isArray(body)) return null;
  return (
    <div className="space-y-4">
      {body.map((block, i) => {
        if (block?.type === "paragraph" && typeof block.text === "string") {
          return <ParagraphBlock key={i} block={block} />;
        }
        if (block?.type === "paragraph_with_link"
            && typeof block.text === "string"
            && typeof block.link_text === "string"
            && typeof block.link_url === "string") {
          return <ParagraphWithLinkBlock key={i} block={block} />;
        }
        if (block?.type === "bullet_list" && Array.isArray(block.items)) {
          return <BulletListBlock key={i} block={block} />;
        }
        // Defence-in-depth: silently skip anything unknown. Do NOT render or
        // execute markup. Optionally log in development only.
        if (process.env.NODE_ENV !== "production") {
          // eslint-disable-next-line no-console
          console.warn("[legal-terms] skipping unknown block", block?.type);
        }
        return null;
      })}
    </div>
  );
}
